import { createSelector } from "@reduxjs/toolkit";

import { IPeopleBlockRSVP } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { buildSingleItem } from "shared/utils";
import { dataSelector, dataMetaSelectorHelper } from "../helpers";

const eventRSVPSelector = createSelector(
  dataSelector,
  (data) => data.eventPeopleBlockUserRsvp
);

export const eventRSVPSelectorCreator = (id: string) =>
  createSelector(eventRSVPSelector, (rsvps) => {
    const rsvp = rsvps?.[API_ENDPOINTS.EVENT_RSVP(id)];

    if (rsvp) {
      return buildSingleItem(rsvp) as IPeopleBlockRSVP;
    }
    return null;
  });

export const eventRSVPSMetaSelector = (id: string) =>
  dataMetaSelectorHelper(API_ENDPOINTS.EVENT_RSVP(id));
